module.exports = ".menus{\r\n   \r\n    color: black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/level1menu/level1menu.component.css
// module id = ./src/app/common/level1menu/level1menu.component.css
// module chunks = main